import { gql } from '@apollo/client'

export const QINIU_TOKEN = gql`
  query qiniuToken(
    $originalFileName: String
    $key: String
    $bucket: OssBucket
    $dirName: String
  ) {
    upToken: ossUploadToken(
      param: {
        originalFileName: $originalFileName
        fileName: $key
        bucket: $bucket
        dirName: $dirName
      }
    ) {
      region
      token
    }
  }
`

export const REPORT_PV = gql`
  mutation reportPV($param: ReportPageViewInput!) {
    status: reportPageView(param: $param)
  }
`

/** 浏览统计 */
export const REPORT_VIEW = gql`
  mutation reportView($input: GeneralSocialActionInput!) {
    squareModule {
      status: doViewAction(param: $input)
    }
  }
`

/** 文本敏感词检测 */
export const TEXT_DETECTION = gql`
  mutation textDetection($input: TextDetectionInput) {
    commonMutation {
      success: textDetection(input: $input)
    }
  }
`

/** 企业咨询行业分类 */
export const ENTER_PRISE_CATEGORY_LIST = gql`
  query enterpriseCategoryList {
    itemModule: copyrightCompanyModuleQuery {
      list: industryCategoryList {
        id
        name
      }
    }
  }
`

/** 提交企业信息 */
export const SUBMIT_INTENTION = gql`
  mutation submitIntention($input: IntentionSubmitInput!) {
    itemModule: copyrightCompanyModuleMutation {
      status: submitIntention(input: $input)
    }
  }
`
